export default __webpack_public_path__ + "static/eoa-45ed4b977caf3a9d102c0ce258a6b8ba.png";